import React, { useEffect, useState } from 'react';
import { SearchIcon } from 'assets/icons';
import { SInput } from 'pages/MyOrdersPage/ClientsOrders/Filter/ClientsOrdersFilter.styled';
import { theme } from 'styles';
import { Flex, Icon } from 'UI';

interface FilterInputFieldProps {
  placeholder: string;
  onChangeDebounced: (value: string) => void;
  value?: string;
  minWidth?: number;
  maxWidth?: number;
  'data-cy'?: string;
}

export const FilterInputField = React.memo(
  ({
    placeholder,
    onChangeDebounced,
    value,
    minWidth = 150,
    maxWidth = 200,
    'data-cy': dataCy,
  }: FilterInputFieldProps) => {
    const [stateValue, setStateValue] = useState<string | undefined>(value);

    useEffect(() => {
      setStateValue(value);
    }, [value]);

    return (
      <Flex minWidth={minWidth} maxWidth={maxWidth}>
        <SInput
          value={stateValue}
          onChange={setStateValue}
          onChangeDebounced={onChangeDebounced}
          placeholder={placeholder}
          data-cy={dataCy}
          prefix={
            <Icon
              IconComponent={SearchIcon}
              size={14}
              display={'block'}
              mt={'auto'}
              mb={'auto'}
              color={theme.color.grey55}
            />
          }
          allowClear
        />
      </Flex>
    );
  },
);

FilterInputField.displayName = 'FilterInputField';
